<template>
    <div
        class="feature-navigation"
        ref="navigation"
        :class="{ '-border-shadow': borderShadow }"
    >
        <div class="header-row" v-if="title != 'false'">
            <div class="feature-title">
                <div class="back-button" @click="goBack" v-if="back">
                    <i class="material-icons">keyboard_backspace</i>
                </div>
                <div class="title-value">
                    {{ navigationTitle }}
                </div>
            </div>
            <div class="navigation-menu">
                <div
                    class="secondary-button"
                    :class="`-${secondaryAction.color}`"
                    @click="emitAction(secondaryAction.action)"
                    v-for="(secondaryAction, index) in secondaryActions"
                    :key="`secondary${index}`"
                >
                    {{ secondaryAction.display }}
                </div>
                <ActionButton
                    style="margin-left: 1rem;"
                    :materialIcon="primaryAction.materialIcon"
                    @click="emitAction(primaryAction.action)"
                    :label="primaryAction.display"
                    v-for="(primaryAction, index) in primaryActions"
                    :color="primaryAction.color"
                    :key="`primary${index}`"
                ></ActionButton>
            </div>
        </div>
        <div class="header-row" v-if="search || filteredFilters.length > 0">
            <div class="navigation-search" v-if="search">
                <i class="material-icons">{{ 'search' }}</i>
                <input
                    @input="searchChanged"
                    type="search"
                    :placeholder="$t('SEARCHBAR_START')"
                />
            </div>
            <div class="navigation-filters" v-if="filteredFilters.length != 0">
                <div class="filters-title">{{ $t('LABEL_FILTERS') }}:</div>
                <div
                    v-for="(filter, index) in filteredFilters"
                    :key="`filter${index}`"
                >
                    <NavigationFilter
                        v-if="filter.type != 'person-filter'"
                        @filterChanged="filterChanged"
                        @initFilters="initFilters"
                        @action="actionEmitted"
                        :filter="filter"
                    ></NavigationFilter>
                    <PersonFilter
                        :filter="filter"
                        v-if="filter.type == 'person-filter'"
                        @filterChanged="filterChanged"
                    ></PersonFilter>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { timeout } from 'q'
export default {
    props: {
        back: Boolean,
        title: String,
        search: Boolean,
        actions: {
            type: Array,
            default: () => {
                return []
            }
        },
        filters: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            selectedFilters: [],
            timeout: timeout,
            filterTimeout: timeout,
            filterInitTimeout: timeout,
            lastPath: '',
            borderShadow: false,
            filterEmitted: false
        }
    },
    computed: {
        filteredFilters() {
            return this.filters.filter(
                filter => this.$Utils.checkRole(filter.roles) && !filter.hidden
            )
        },
        primaryActions() {
            return this.actions.filter(
                action =>
                    action.type == 'primary' &&
                    this.$Utils.checkTeacherPerm(action.permission) &&
                    this.$Utils.checkRole(action.roles)
            )
        },
        secondaryActions() {
            return this.actions.filter(
                action =>
                    action.type == 'secondary' &&
                    this.$Utils.checkTeacherPerm(action.permission) &&
                    this.$Utils.checkRole(action.roles)
            )
        },
        navigationTitle() {
            return this.title ? this.title : this.$t(this.$route.meta.display)
        }
    },
    methods: {
        actionEmitted(action) {
            this.$emit('action', action)
        },
        goBack() {
            this.$router.push(this.$store.state.lastPath)
        },
        searchChanged($event) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.$emit('search', $event.target.value)
            }, 1000)
        },
        prepareFilters(filter) {
            switch (filter.type) {
                case 'select':
                    this.selectedFilters[filter.key] = filter.options
                        .map(option => {
                            if (option.selected) {
                                return option.key
                            }
                        })
                        .filter(option => option)
                    break
                case 'person-filter':
                    this.selectedFilters[filter.key] = filter.options
                        .map(option => {
                            if (option.selected) {
                                return option.key
                            }
                        })
                        .filter(option => option)
                    break
                case 'date':
                    this.selectedFilters[filter.key] = filter.value
                    break
            }
            if (
                this.selectedFilters[filter.key] &&
                this.selectedFilters[filter.key].length == 0
            ) {
                delete this.selectedFilters[filter.key]
            }
        },
        initFilters() {
            clearTimeout(this.filterInitTimeout)
            this.filterInitTimeout = setTimeout(() => {
                if (!this.filters || this.filterEmitted) {
                    return
                }
                this.filters.forEach(filter => {
                    this.prepareFilters(filter)
                })
                this.$emit('filterChanged', this.selectedFilters)
            }, 500)
        },
        filterChanged(filter) {
            this.filterEmitted = true
            clearTimeout(this.filterTimeout)
            this.prepareFilters(filter)
            this.filterTimeout = setTimeout(() => {
                this.$emit('filterChanged', this.selectedFilters)
            }, 500)
        },
        emitAction(action) {
            this.$emit('action', action)
        }
    }
}
</script>
<style lang="scss" scoped>
.header-row {
    min-height: 3.5rem;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    &:not(:first-of-type) {
        margin-top: 0.5rem;
    }
}
.navigation-menu {
    display: flex;
    align-items: center;
}
.title-value {
    max-width: 30rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.title-icon {
    margin-right: 1rem;
}
.back {
    margin-right: 1rem;
    background-color: lighten($main-accent, 20%);
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    transition: $ease;

    &:hover {
        background-color: lighten($main-accent, 0%);
    }
}
.back img {
    height: 50%;
}
.navigation-filters {
    display: flex;
    align-items: center;
    margin-left: auto;
    justify-self: flex-end;
}
.back-button {
    background: $main-accent;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    border-radius: 100%;
    transition: $ease;
    z-index: $high;
    pointer-events: all;
    margin-right: 1rem;
    cursor: pointer;
    padding: 0.5rem;
    box-sizing: border-box;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.back-button i {
    color: $background;
    font-size: 2rem;
}
.filters-title {
    font-size: 0.9rem;
    font-family: $input-family;
}
</style>
